import {BroadcastEvents} from "@/app/broadcast/BroadcastEvents.js";
import {emitter, EmitterEvents} from "@/shared/services/Emitter.js";

export const broadcastChannel = new BroadcastChannel('how2spanish-messages');

export const registerBroadcastEvents = () => {
    broadcastChannel.addEventListener('message', async (event) => {
        if (!event.data) return ;

        const { type, payload } = event.data;

        switch (type) {
            case BroadcastEvents.FinishOnboarding:
                emitter.emit(EmitterEvents.broadcastFinishOnboarding, payload);
                break;
        }
    });
}

export const broadcastFinishOnboarding = () => {
    broadcastChannel.postMessage({ type: BroadcastEvents.FinishOnboarding });
}
